import React from "react";

const About = () => {
  return (
    <section
      id="tentang"
      data-testid="about-section"
      className="relative py-24 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <div className="text-xs tracking-[0.22em] uppercase text-[#9B5BFF] font-medium">
            — Tentang Kami
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl mt-4 leading-[1.05]">
            Sahabat Digital <br />
            <span className="gradient-purple">Anda yang Terpercaya.</span>
          </h2>
        </div>
        <div className="lg:col-span-7">
          <p className="text-white/70 text-base sm:text-lg leading-[1.85]">
            <span className="text-white font-semibold">DIGIFRIEND</span> adalah
            layanan digital terpercaya yang menyediakan berbagai kebutuhan
            premium digital seperti{" "}
            <span className="text-[#cdb6ff]">akun premium</span>,{" "}
            <span className="text-[#cdb6ff]">game repack aman terpercaya</span>,
            serta{" "}
            <span className="text-[#cdb6ff]">koleksi e-book bermanfaat</span>{" "}
            dengan harga terjangkau dan pelayanan cepat. Kami berkomitmen
            menghadirkan pengalaman belanja digital yang aman, transparan, dan
            ramah pengguna.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4 sm:gap-6">
            {[
              { num: "500+", label: "Pelanggan Puas" },
              { num: "24/7", label: "Fast Response" },
              { num: "100%", label: "Aman & Trusted" },
            ].map((s) => (
              <div
                key={s.label}
                className="glass rounded-2xl p-4 sm:p-5 text-center"
              >
                <div className="font-display text-2xl sm:text-3xl font-extrabold gradient-purple">
                  {s.num}
                </div>
                <div className="mt-1 text-[11px] sm:text-xs uppercase tracking-[0.16em] text-white/55">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
